import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollTriggerSimple from "../helpers/scrollTriggerSimple";

function Design() {
  const buttonclassName =
    "relative xs:block xs:!mt-12 sm:!ml-4 xl:!ml-12 xs:m-auto lg:mt-16 lg:ml-0 lg:display-inline content-center text-xs bg-transparent hover:bg-[#EDB6A2] text-[#EDB6A2] sm:text-[16px] sm:leading-[25px] xl:text-[20px] xl:leading-[30px] font-gothMed hover:text-white py-3 px-8 border border-[#707070] hover:border-transparent rounded ";

  // const bodyCopyclassName =
  //   "xs:text-center sm:text-left xs:px-5 xs:py-10 sm:px-10 md:pl-12 lg:pl-36 xl:pl-60 sm:py-20 lg:py-28 xs:text-[22px] xs:leading-[30px] sm:text-[30px] text-[#EDB6A2] sm:leading-[48px] xl:text-[2rem] xl:leading-[45px] font-ppNeue";

  // let aboutScroll = useRef(null);
  // let aboutScrollCont = useRef(null);
  // let aboutPageCopy1 = useRef(null);
  // let aboutPageCopy2 = useRef(null);
  let aboutSelectBox = useRef(null);
  let aboutCImageCont = useRef(null);
  let aboutCImage0 = useRef(null);
  let aboutCImage1 = useRef(null);
  let aboutCImage2 = useRef(null);
  let aboutCImage3 = useRef(null);
  let aboutCImage4 = useRef(null);
  // let aboutPageCopy3 = useRef(null);
  // let aboutImage2 = useRef(null);
  // let aboutPageCopy4 = useRef(null);
  // let aboutPageCopy5 = useRef(null);
  // let aboutCta = useRef(null);
  let previousImage = useRef(null);
  let nextImage = useRef(null);
  let cTitleAni0 = useRef(null);
  let cCopyAni0 = useRef(null);
  let cTitleAni1 = useRef(null);
  let cCopyAni1 = useRef(null);
  let cTitleAni2 = useRef(null);
  let cCopyAni2 = useRef(null);
  let cTitleAni3 = useRef(null);
  let cCopyAni3 = useRef(null);
  // let cTitleAni4 = useRef(null);
  // let cCopyAni4 = useRef(null);

  let whichSlide = 0;
  let canClick = true;

  const cArray = [
    [aboutCImage0, cTitleAni0, cCopyAni0],
    [aboutCImage1, cTitleAni1, cCopyAni1],
    [aboutCImage2, cTitleAni2, cCopyAni2],
    [aboutCImage3, cTitleAni3, cCopyAni3],
    // [aboutCImage4, cTitleAni4, cCopyAni4],
  ];

  const previousSlide = () => {
    if (canClick === true) {
      canClick = false;
      gsap.to([cArray[whichSlide][0].current, cArray[whichSlide][1].current, cArray[whichSlide][2].current, previousImage.current, nextImage.current], 0.25, {
        autoAlpha: 0,
        display: "none",
      });

      whichSlide--;
      if (whichSlide < 0) {
        whichSlide = 3;
      }

      // setCTitle(cArray[whichSlide][1]);
      // setCCopy(cArray[whichSlide][2]);
      gsap.to([cArray[whichSlide][0].current, cArray[whichSlide][1].current, cArray[whichSlide][2].current, previousImage.current, nextImage.current], 0.25, {
        autoAlpha: 1,
        display: "inline-block",
        delay: 0.25,
        onComplete: function () {
          canClick = true;
        },
      });
    }
  };

  const nextSlide = () => {
    if (canClick === true) {
      canClick = false;

      gsap.to([cArray[whichSlide][0].current, cArray[whichSlide][1].current, cArray[whichSlide][2].current, previousImage.current, nextImage.current], 0.25, {
        autoAlpha: 0,
        display: "none",
      });
      whichSlide++;
      if (whichSlide > 3) {
        whichSlide = 0;
      }
      // setCTitle(cArray[whichSlide][1]);
      // setCCopy(cArray[whichSlide][2]);
      gsap.to([cArray[whichSlide][0].current, cArray[whichSlide][1].current, cArray[whichSlide][2].current, previousImage.current, nextImage.current], 0.25, {
        autoAlpha: 1,
        delay: 0.25,
        display: "inline-block",
        onComplete: function () {
          canClick = true;
        },
      });
    }
  };

  //const { ref: homePageTitle1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: aboutImage1 } = ScrollTriggerSimple(50, 0, "50% 45%", "100% 55%");
  const { ref: aboutPageCopy1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: aboutPageCopy2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: aboutPageCopy3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: aboutImage2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: aboutPageCopy4 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: aboutPageCopy5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: aboutCta } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");

  // const { ref: aboutShowCaseCopy1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseCopy1_5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseImage1 } = ScrollTriggerSimple(0, 50, "-50% 70%", "bottom 70%");

  // const { ref: aboutShowCaseCopy2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseCopy2_5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseImage2 } = ScrollTriggerSimple(0, -50, "-50% 70%", "bottom 70%");

  // const { ref: aboutShowCaseCopy3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseCopy3_5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseImage3 } = ScrollTriggerSimple(0, 50, "-50% 70%", "bottom 70%");

  // const { ref: aboutShowCaseCopy4 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseCopy4_5 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  // const { ref: aboutShowCaseImage4 } = ScrollTriggerSimple(0, -50, "-50% 70%", "bottom 70%");

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
  }, []);

  return (
    <>
      <section className="overflow-hidden bg-[#141833]">
        <article className="xs:py-20 xs:px-10 lg:px-36 sm:py-36 md:py-36 lg:py-30 bg-[#141833] flex">
          <p ref={aboutPageCopy1} className="content-center xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[3rem] lg:w-[900px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[825px] sm:px-4 xl:px-12 font-ppNeue">
            Our story begins with our Founder, Gordon Morrison, who provided the inspiration, innovation and impetus behind one of the largest construction companies in the UK; a business that has delivered billions of public and private sector projects in the UK and overseas.
          </p>
        </article>

        {/* <article ref={aboutScrollCont} className="">
          <div
            ref={aboutScroll}
            className="text-right bg-[#141833] relative xs:w-[2000px] md:w-[3000px] xs:right-[500px]  md:right-[-400px]"
          >
            <img
              className="xs:w-[340px] md:w-[674px] xs:pl-8 md:pl-16 inline"
              alt=""
              src="../images/aboutScroll1.jpg"
            ></img>
            <img
              className="xs:w-[340px] md:w-[674px] inline xs:pl-8 md:pl-16"
              alt=""
              src="../images/aboutScroll1.jpg"
            ></img>
            <img
              className="xs:w-[340px] md:w-[674px] inline xs:pl-8 md:pl-16"
              alt=""
              src="../images/aboutScroll1.jpg"
            ></img>
            <img
              className="xs:w-[340px] md:w-[674px] inline xs:pl-8 md:pl-16"
              alt=""
              src="../images/aboutScroll1.jpg"
            ></img>
          </div>
        </article> */}
        <article className="text-left">
          <div ref={aboutImage1} style={{ backgroundImage: `url("../images/aboutCraft.jpg")` }} alt="hero" className="bg-no-repeat bg-center bg-cover relative h-[50vh] w-full"></div>
        </article>
        <article className="xs:py-20 xs:px-10 lg:px-36 sm:py-36 md:py-36 lg:py-30 bg-[#141833] text-center">
          <p ref={aboutPageCopy2} className="text-center content-center m-auto xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[3rem] lg:w-[825px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[825px] sm:px-4 xl:px-12 font-ppNeue">
            He is a master engineer in the mould of the great Victorian Isambard Kingdom Brunel, but with 21st century technological knowhow. He is a perfectionist who has developed an incredible CV which includes:
          </p>
        </article>
        {/* <article className={bodyCopyclassName}>
          <p ref={aboutShowCaseCopy1} className="font-bold">
            THE FALKIRK WHEEL
          </p>
          <p ref={aboutShowCaseCopy1_5} className="pt-8 text-[1.3rem] leading-8">
            A rotating boat lift in Tamfourhill, central Scotland, connecting the Forth and Clyde
            <br className="sm:hidden lg:block"></br>
            Canal with the Union Canal. The wheel, which lifts canal cruisers by 24 metres, is the
            <br className="sm:hidden lg:block"></br>
            only rotating boat lift of its kind in the world.
          </p>
        </article>
        <article className="text-right">
          <img
            ref={aboutShowCaseImage1}
            className="inline-block"
            alt=""
            src="../images/aboutC1.jpg"
          ></img>
        </article>

        <article className={bodyCopyclassName}>
          <p ref={aboutShowCaseCopy2} className="font-bold">
            Ministry of Defence
          </p>
          <p ref={aboutShowCaseCopy2_5} className="pt-8 text-[1.3rem] leading-8">
            Top secret Ministry of Defence contracts for nuclear submarines. We could tell you about
            <br className="sm:hidden lg:block"></br>
            them, but we would have to kill you afterwards!
          </p>
        </article>
        <article className="text-left">
          <img
            ref={aboutShowCaseImage2}
            className="inline-block"
            alt=""
            src="../images/aboutC2.jpg"
          ></img>
        </article>

        <article className={bodyCopyclassName}>
          <p ref={aboutShowCaseCopy3} className="font-bold">
            Kylesku Bridge
          </p>
          <p ref={aboutShowCaseCopy3_5} className="pt-8 text-[1.3rem] leading-8">
            Reconstruction in Kuwait after First Gulf War in 1991
          </p>
        </article>
        <article className="text-right">
          <img
            ref={aboutShowCaseImage3}
            className="inline-block"
            alt=""
            src="../images/aboutC3.jpg"
          ></img>
        </article>

        <article className={bodyCopyclassName}>
          <p ref={aboutShowCaseCopy4} className="font-bold">
            Kylesku Bridge
          </p>
          <p ref={aboutShowCaseCopy4_5} className="pt-8 text-[1.3rem] leading-8">
            Edinburgh opened in 1994
          </p>
        </article> */}
        {/* <article className="text-left">
          <img
            ref={aboutShowCaseImage4}
            className="inline-block"
            alt=""
            src="../images/aboutC4.jpg"
          ></img>
        </article> */}
        <div ref={aboutCImageCont} className="relative sm:w-full md:m-auto md:w-[716px]">
          <img ref={aboutCImage0} className="inline-block absolute sm:w-full md:w-auto" alt="" src="../images/aboutC1.jpg"></img>
          <img ref={aboutCImage1} className="inline-block absolute opacity-0 sm:w-full  md:w-auto" alt="" src="../images/aboutC2.jpg"></img>
          <img ref={aboutCImage2} className="inline-block absolute opacity-0 sm:w-full  md:w-auto" alt="" src="../images/aboutC3.jpg"></img>
          <img ref={aboutCImage3} className="inline-block absolute opacity-0 sm:w-full  md:w-auto" alt="" src="../images/aboutC4.jpg"></img>
          <img ref={aboutCImage4} className="inline-block absolute opacity-0 sm:w-full  md:w-auto" alt="" src="../images/aboutC5.jpg"></img>
          <img className="inline-block relative opacity-0 sm:w-full  md:w-auto" alt="" src="../images/aboutCEmpty.png"></img>
        </div>
        <div ref={aboutSelectBox} className="sm:w-full md:max-w-[716px] m-auto xs:h-[auto] lg:h-auto border border-[#EDB6A2] sm:relative md:relative background-fffff md:left-none xs:right-0  bg-[#141833]/80 xs:p-4 md:p-10">
          <p ref={cTitleAni0} className="content-center xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] lg:text-3xl lg:!leading-[3rem] xl:text-3xl xl:!leading-[3.2rem] pb-8 font-ppNeue">
            The Falkirk Wheel
          </p>
          <p ref={cCopyAni0} className="content-center xs:text-xl sm:text-1xl md:text-1xl text-[#EDB6A2] lg:text-1xl lg:!leading-[2.2rem] xl:text-1xl xl:!leading-[2.2rem] w-full font-ppNeue">
            A rotating boat lift in Tamfourhill, central Scotland, connecting the Forth and Clyde Canal with the Union Canal. The wheel, which lifts canal cruisers by 24 metres, is the only rotating boat lift of its kind in the world.
          </p>
          <p ref={cTitleAni1} className="content-center hidden xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] lg:text-3xl lg:!leading-[3rem] xl:text-3xl xl:!leading-[3.2rem] pb-8 font-ppNeue">
            Ministry of Defence
          </p>
          <p ref={cCopyAni1} className="content-center hidden xs:text-xl sm:text-1xl md:text-1xl text-[#EDB6A2] lg:text-1xl lg:!leading-[2.2rem] xl:text-1xl xl:!leading-[2.2rem] w-full font-ppNeue">
            Top secret Ministry of Defence contracts for nuclear submarines. We could tell you about them, but we would have to kill you afterwards!
          </p>
          <p ref={cTitleAni2} className="content-center hidden xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] lg:text-3xl lg:!leading-[3rem] xl:text-3xl xl:!leading-[3.2rem] pb-8 font-ppNeue">
            Kylesku Bridge
          </p>
          <p ref={cCopyAni2} className="content-center hidden xs:text-xl sm:text-1xl md:text-1xl text-[#EDB6A2] lg:text-1xl lg:!leading-[2.2rem] xl:text-1xl xl:!leading-[2.2rem] w-full font-ppNeue">
            Opened in 1984 and listed as a Category A Structure in 2019.
          </p>
          <p ref={cTitleAni3} className="content-center hidden xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] lg:text-3xl lg:!leading-[3rem] xl:text-3xl xl:!leading-[3.2rem] pb-8 font-ppNeue">
            Kuwait
          </p>
          <p ref={cCopyAni3} className="content-center hidden xs:text-xl sm:text-1xl md:text-1xl text-[#EDB6A2] lg:text-1xl lg:!leading-[2.2rem] xl:text-1xl xl:!leading-[2.2rem] w-full font-ppNeue">
            Reconstruction in Kuwait after First Gulf War in 1991.
          </p>
          {/* <p
            ref={cTitleAni4}
            className="content-center hidden xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] lg:text-3xl lg:!leading-[3rem] xl:text-3xl xl:!leading-[3.2rem] pb-16 font-ppNeue"
          >
            Exchange Plaza
          </p>
          <p
            ref={cCopyAni4}
            className="content-center hidden xs:text-xl sm:text-1xl md:text-1xl text-[#EDB6A2] lg:text-1xl lg:!leading-[2.2rem] xl:text-1xl xl:!leading-[2.2rem] font-ppNeue"
          >
            Edinburgh opened in 1994
          </p> */}
          <div className="pt-10">
            <button onClick={() => previousSlide()} ref={previousImage} className="w-10 h-10 rounded-full text-[#EDB6A2] font-mono border border-[#EDB6A2] hover:bg-[#EDB6A2] hover:text-[#FFFFFF]">
              &#60;
            </button>
            <button onClick={() => nextSlide()} ref={nextImage} className="w-10 h-10 rounded-full text-[#EDB6A2] font-mono border border-[#EDB6A2] float-right hover:bg-[#EDB6A2] hover:text-[#FFFFFF]">
              &#62;
            </button>
          </div>
        </div>
        <article className="xs:py-20 xs:px-10 lg:px-36 sm:py-36 md:py-36 lg:py-30 bg-[#141833] flex">
          <p ref={aboutPageCopy3} className="content-center xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[3rem] lg:w-[900px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[825px] sm:px-4 xl:px-12 font-ppNeue">
            Nowadays, via Chaldean Prime he uses his vast knowledge and experience, to turn his hand to super-luxury, uber cool and incredibly desirable residential developments.
          </p>
        </article>
        <article className="text-left">
          <div ref={aboutImage2} style={{ backgroundImage: `url("../images/about3.jpg")` }} alt="hero" className="bg-no-repeat bg-center bg-cover relative h-[65vh] w-full"></div>
        </article>
        <article className="items-end bg-[#141833] xs:block lg:flex">
          <div className="inline-block align-middle xs:w-full lg:w-2/4 xs:px-10 xs:py-32 lg:pl-32">
            <p ref={aboutPageCopy4} className="content-end xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[2.8rem] lg:w-[600px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[850px] sm:px-4 xl:px-12 font-ppNeue">
              For Gordon Morrison, perfection isn’t an aim, it’s a demand. Perfection is part of his DNA and this ethos is at the heart of everything we create.
            </p>
            <p ref={aboutPageCopy5} className="content-center xs:text-xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[2.8rem] lg:w-[600px] xl:text-3xl xl:!leading-[2.8rem] xl:w-[850px] sm:px-4 xl:px-12 pt-8 font-ppNeue">
              He would only create a home that he would be proud to put his name to and very proud to live in.
            </p>
            <a href="/design" rel="none">
              <button ref={aboutCta} className={buttonclassName}>
                SEE MORE
              </button>
            </a>
          </div>
          <div className="w-2/4 text-right">
            <img className="xs:hidden lg:inline-block xs:w-[400px] sm:w-[400px] md:" alt="" src="../images/aboutLogo.png"></img>
          </div>
        </article>
        <article className="text-left">
          <div style={{ backgroundImage: `url("../images/aboutFooter.webp")` }} alt="hero" className="bg-no-repeat bg-center bg-cover relative h-[75vh] w-full"></div>
        </article>
      </section>
    </>
  );
}

export default Design;
